import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useApiV2ModelContext } from '../../../contexts/ApiV2ModelContext';
import { EmptyRange } from './EmptyRange';
import { LoadingMetrics } from './LoadingMetrics';
import { PullRequestListQuery } from './PullRequestListQuery';
import { VCS_SLUG } from '../../../constants/api';
export const MetricsQuery = ({ repositories, timezoneId, activeRepositoriesIds, from, to, pollInterval, user, handleRegisterRepo, }) => {
    const apiV2ModelContext = useApiV2ModelContext();
    const [loading, setLoading] = useState(true);
    const [pullRequestMetrics, setPullRequestMetrics] = useState(null);
    // @ToDo: Make both queries in a single request as GraphQL allows.
    const fetchPullRequestMetrics = async () => {
        const results = await apiV2ModelContext.getPullRequestMetrics(timezoneId, activeRepositoriesIds, from, to, pollInterval);
        setPullRequestMetrics(results);
        setLoading(false);
    };
    useEffect(() => {
        fetchPullRequestMetrics();
    }, [activeRepositoriesIds, from, to]);
    if (!pullRequestMetrics?.pullRequestsMetrics || pullRequestMetrics?.pullRequestsMetrics.length <= 1) {
        return _jsx(EmptyRange, {});
    }
    if (loading) {
        return _jsx(LoadingMetrics, {});
    }
    const repos = repositories.list[VCS_SLUG[user.user.vcs]] || {};
    return _jsx(PullRequestListQuery, { activeRepositoriesIds: activeRepositoriesIds, pullRequestMetrics: pullRequestMetrics?.pullRequestsMetrics ?? [], repos: repos, repositories: repositories, user: user, from: from, to: to, handleRegisterRepo: handleRegisterRepo });
};
